export default "__VITE_ASSET__riMqws1O__"